module.exports = __webpack_public_path__ + "static/custj1-c1fb86084dc9c20474fe9d3098bb3ab3.png";